import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiRequest } from '../hooks/useApi.js'
import { useAnnouncer } from '../contexts/AnnouncerContext.jsx'

export default function SettingsScreen() {
  const navigate = useNavigate()
  const { announce, alertSR } = useAnnouncer()

  const [difficulty, setDifficulty] = useState('intermediario')
  const [beepEnabled, setBeepEnabled] = useState(false)
  const [tutorialMode, setTutorialMode] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const data = await apiRequest('GET', '/stats')
        if (!cancelled) {
          setDifficulty(data.difficulty || 'intermediario')
          setBeepEnabled(data.beep_enabled || false)
          setTutorialMode(data.tutorial_mode || false)
        }
      } catch (err) {
        if (!cancelled) {
          alertSR(`Erro ao carregar configurações: ${err.message}`)
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [alertSR])

  async function handleSubmit(e) {
    e.preventDefault()
    setSaving(true)
    try {
      await apiRequest('PUT', '/preferences', {
        difficulty,
        beep_enabled: beepEnabled,
        tutorial_mode: tutorialMode,
      })
      announce('Configurações salvas com sucesso.')
    } catch (err) {
      alertSR(`Erro ao salvar configurações: ${err.message}`)
    } finally {
      setSaving(false)
    }
  }

  return (
    <section aria-labelledby="settings-heading">
      <h2 id="settings-heading">Configurações</h2>
      {loading ? (
        <p>Carregando...</p>
      ) : (
        <form id="settings-form" noValidate onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="settings-difficulty">Dificuldade padrão</label>
            <select
              id="settings-difficulty"
              value={difficulty}
              onChange={(e) => setDifficulty(e.target.value)}
            >
              <option value="iniciante">Iniciante</option>
              <option value="intermediario">Intermediário</option>
              <option value="expert">Expert</option>
            </select>
          </div>

          <div className="form-group checkbox-group">
            <input
              type="checkbox"
              id="settings-beep"
              checked={beepEnabled}
              onChange={(e) => setBeepEnabled(e.target.checked)}
            />
            <label htmlFor="settings-beep">Ativar sons (beep)</label>
          </div>

          <div className="form-group checkbox-group">
            <input
              type="checkbox"
              id="settings-tutorial"
              checked={tutorialMode}
              onChange={(e) => setTutorialMode(e.target.checked)}
            />
            <label htmlFor="settings-tutorial">Modo tutorial</label>
          </div>

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar configurações'}
          </button>
        </form>
      )}
      <button type="button" className="btn btn-secondary" onClick={() => navigate('/menu')}>
        Voltar ao menu
      </button>
    </section>
  )
}
